var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot",attrs:{"onboarding":"foot"}},[_c('com-actions',{staticClass:"foot-actions"}),_vm._m(0),_c('div',{staticClass:"foot-clock",attrs:{"onboarding":"foot.clock"}},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.time,'HH:mm')))])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot-text"},[_vm._v(" designed by "),_c('b',[_vm._v("Professional Role Players")])])
}]

export { render, staticRenderFns }